module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_wangen-0b613a3b59fcddf54936f7a358407306.png";